(ns common.widgets.daterange-picker
  (:require ["@mui/material/List$default" :as List]
            ["@mui/material/ListItemButton$default" :as ListItemButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/x-date-pickers-pro/DateRangePicker" :refer [DateRangePicker]]
            ["@mui/x-date-pickers-pro/SingleInputDateRangeField" :refer [SingleInputDateRangeField]]
            ["moment/min/moment-with-locales$default" :as moment]
            ["src/svg/objects/calendar.svg$default" :as Calendar]
            [cljs-bean.core :refer [->js]]
            [clojure.spec.alpha :as spec]
            [common.util :refer [spread-obj]]
            [uix.core :as uix :refer [$ defui]]))

(spec/def :daterange-picker/value (spec/and (spec/or :seq sequential?
                                                     :array array?)
                                            #(= (count %) 2)))

(spec/def :daterange-picker/onChange fn?)

(spec/def :daterange-picker/props
  (spec/keys :req-un [:daterange-picker/value
                      :daterange-picker/onChange]))

(defn shortcuts-items []
  [{:id "last_full_week"
    :label "Last full week"
    :getValue (fn []
                (let [start (-> (moment) (.subtract 7 "days") (.startOf "week"))
                      end (-> (moment) (.subtract 7 "days") (.endOf "week"))]
                  #js [start end]))}
   {:id "last_full_month"
    :label "Last full month"
    :getValue (fn []
                (let [start (-> (moment) (.subtract 1 "month") (.startOf "month"))
                      end (-> (moment) (.subtract 1 "month") (.endOf "month"))]
                  #js [start end]))}
   {:id "last_full_year"
    :label "Last full year"
    :getValue (fn []
                (let [start (-> (moment) (.subtract 1 "year") (.startOf "year"))
                      end (-> (moment) (.subtract 1 "year") (.endOf "year"))]
                  #js [start end]))}
   {:id "last_30_days"
    :label "Last 30 days"
    :getValue (fn []
                (let [start (-> (moment) (.subtract 31 "days"))
                      end (-> (moment) (.subtract 1 "days"))]
                  #js [start end]))}
   {:id "month_to_today"
    :label "This month"
    :getValue (fn []
                (let [start (-> (moment) (.startOf "month"))
                      end (-> (moment))]
                  #js [start end]))}
   {:id "quarter_to_today"
    :label "This quarter"
    :getValue (fn []
                (let [start (-> (moment) (.startOf "quarter"))
                      end (-> (moment))]
                  #js [start end]))}
   {:id "year_to_today"
    :label "This year"
    :getValue (fn []
                (let [start (-> (moment) (.startOf "year"))
                      end (-> (moment))]
                  #js [start end]))}
   {:id "lifetime"
    :label "Lifetime"
    :getValue (fn []
                (let [start (-> (moment "2021-01-01"))
                      end (-> (moment))]
                  #js [start end]))}])

(def Shortcuts
  (uix/as-react
   (fn [{:keys [className onChange value items]}]
     ($ :div {:class className}
        ($ List
           {:component Stack
            :gap 0.5
            :sx #js {:py 0}}
           (for [^js item items]
             ($ ListItemButton
                {:key (.-id item)
                 :onClick #(onChange (.getValue item value))
                 :disabled (when (fn? (.-isDisabled item))
                             (.isDisabled item value))
                 :sx #js {:px 1
                          :py 0.5
                          :borderRadius 1}}
                (.-label item))))))))

(defui daterange-picker
  [{:keys [value error helperText onBlur onChange shortcuts slots slotProps placeholder] :as props
    :or {shortcuts (shortcuts-items)}}]
  {:pre [(spec/assert :daterange-picker/props props)]}
  ($ DateRangePicker
     (merge
      (dissoc props :value :error :helperText :onChange :shortcuts :placeholder)
      {:value #js [(some-> value first moment)
                   (some-> value second moment)]
       :onChange #(onChange (js->clj %))
       :onClose onBlur
       :slots (spread-obj #js {:shortcuts Shortcuts
                               :field SingleInputDateRangeField}
                          slots)
       :slotProps (spread-obj #js {:shortcuts #js {:value value
                                                   :onChange onChange
                                                   :items (->js shortcuts)}
                                   :textField #js {:error error
                                                   :helperText helperText
                                                   :inputProps (when placeholder
                                                                 #js {:placeholder placeholder})
                                                   :InputProps #js {:startAdornment ($ SvgIcon
                                                                                       {:inheritViewBox true
                                                                                        :sx #js {:mr 1
                                                                                                 :cursor "pointer"}}
                                                                                       ($ Calendar))}}}
                              slotProps)})))
